module.exports = __webpack_public_path__ + "img/cursed-banana.42751a99.png";